import { createSlice } from '@reduxjs/toolkit'
import { getInitialFamilyCacheState } from './types'
import { visitTypesReducers } from './entities/visit-types.reducers'
import { illnessesesReducers } from './entities/illnesses.reducers'
import { medicinesReducers } from './entities/medicines.reducers'
import { vaccinesReducers } from './entities/vaccines.reducers'
import { diaryTypesReducers } from './entities/diary-types.reducers'
import { diaryTypeReducers } from './entities/diary-type.reducers'
import { growthMeasuresReducers } from './entities/growth-measure.reducers'
import { beveragesReducers } from './entities/beverages.reducers'
export const FAMILY_CACHE_PURGE_INTERVAL_MS = 60 * 1000

export const familySlice = createSlice({
  name: 'familyCache',
  initialState: getInitialFamilyCacheState(),
  reducers: {
    ...visitTypesReducers,
    ...illnessesesReducers,
    ...medicinesReducers,
    ...vaccinesReducers,
    ...beveragesReducers,
    ...diaryTypesReducers,
    ...diaryTypeReducers,
    ...growthMeasuresReducers,
  },
})

export const {
  addVisitTypes,
  removeVisitTypes,
  purgeExpiredVisitTypesCache,

  addIllnesseses,
  removeIllnesseses,
  purgeExpiredIllnessesCache,

  addMedicines,
  removeMedicines,
  purgeExpiredMedicinesCache,

  addVaccinesKey,
  removeVaccinesKey,
  purgeExpiredVaccinesCache,

  addBeverages,
  removeBeverages,
  purgeExpiredBeveragesCache,

  addDiaryTypesKey,
  removeDiaryTypesKey,
  purgeExpiredDiaryTypesCache,

  addDiaryTypeKey,
  removeDiaryTypeKey,
  purgeExpiredDiaryTypeCache,

  addGrowthMeasures,
  removeGrowthMeasures,
  purgeExpiredGrowthMeasuresCache,
} = familySlice.actions
